export const minDate = "2023-01-01";